import { Settings } from './settings';

const servicesConfig = window['servicesConfig'];

//TODO - move this into a new service
export let AppSettings: Settings = null;

function init(): void {
    if (!AppSettings) {
        const defaultSettings = new Settings();
        for (const key in defaultSettings) {
            if (servicesConfig) {
                if (!servicesConfig[key]) {
                    console.warn('Setting %s not found in services.config.js', key);
                }
            }
        }
        AppSettings = {
            ...defaultSettings,
            ...(servicesConfig || {})
        } as Settings;
    }
}

init();
